export default __webpack_public_path__ + "static/media/how-it-works-diagram.08b76564.png";